import React from 'react'
import ProductCompo from './ProductCompo'



const P1Lan = () => {
  return (
    <div>

      <ProductCompo
      title="General SOP"
      major="Review SOP"
      price="$15.00 USD"
      words="275"
      description="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore"
      features={['SOP review', 'Proffesional writer', 'Quick Delivery']}
      details={[
        { label: 'Service Type', value: 'SOP review' },
        { label: 'Service Name', value: 'General SOP' },
        { label: 'words', value: '275' },
        { label: 'Completion time', value: '2-3 weeks' },
      ]}

      breadcrumbs={[
        { label: 'Home', href: '/' },
        { label: 'Our Products', href: '/OurProducts' },
        { label: 'General SOP', href: '#', isCurrentPage: true },
      ]}

      />
    </div>
  )
}

export default P1Lan



